import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { Attachments_OperationService } from './Attachments.operation.service';
import { Carriers_OperationService } from './Carriers.operation.service';
import { Instructions_OperationService } from './Instructions.operation.service';
import { LoadContainers_OperationService } from './LoadContainers.operation.service';
import { Lots_OperationService } from './Lots.operation.service';
import { SerialNumbers_OperationService } from './SerialNumbers.operation.service';
import { Owners_OperationService } from './Owners.operation.service';
import { Discussions_OperationService } from './Discussions.operation.service';
import { ExcelOrderImport_OperationService } from './ExcelOrderImport.operation.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { DockAppointments_OperationService } from './DockAppointments.operation.service';
import { Notifications_OperationService } from './Notifications.operation.service';
import { Addresses_OperationService } from './Addresses.operation.service';
import { Materials_OperationService } from './Materials.operation.service';
import { Locations_OperationService } from './Locations.operation.service';
import { AsnOrders_OperationService } from './AsnOrders.operation.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { Inventory_OperationService } from './Inventory.operation.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';


@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_OperationService {

  constructor(
    private injector: Injector,
    private utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Attachments = this.injector.get(Attachments_OperationService);
    this.Carriers = this.injector.get(Carriers_OperationService);
    this.Instructions = this.injector.get(Instructions_OperationService);
    this.LoadContainers = this.injector.get(LoadContainers_OperationService);
    this.Lots = this.injector.get(Lots_OperationService);
    this.SerialNumbers = this.injector.get(SerialNumbers_OperationService);
    this.Owners = this.injector.get(Owners_OperationService);
    this.Discussions = this.injector.get(Discussions_OperationService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_OperationService);
    this.Invoices = this.injector.get(Invoices_OperationService);
    this.DockAppointments = this.injector.get(DockAppointments_OperationService);
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.Addresses = this.injector.get(Addresses_OperationService);
    this.Materials = this.injector.get(Materials_OperationService);
    this.Locations = this.injector.get(Locations_OperationService);
    this.AsnOrders = this.injector.get(AsnOrders_OperationService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_OperationService);
    this.Inventory = this.injector.get(Inventory_OperationService);
    this.SalesOrders = this.injector.get(SalesOrders_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public Attachments: Attachments_OperationService;
    public Carriers: Carriers_OperationService;
    public Instructions: Instructions_OperationService;
    public LoadContainers: LoadContainers_OperationService;
    public Lots: Lots_OperationService;
    public SerialNumbers: SerialNumbers_OperationService;
    public Owners: Owners_OperationService;
    public Discussions: Discussions_OperationService;
    public ExcelOrderImport: ExcelOrderImport_OperationService;
    public Invoices: Invoices_OperationService;
    public DockAppointments: DockAppointments_OperationService;
    public Notifications: Notifications_OperationService;
    public Addresses: Addresses_OperationService;
    public Materials: Materials_OperationService;
    public Locations: Locations_OperationService;
    public AsnOrders: AsnOrders_OperationService;
    public PurchaseOrders: PurchaseOrders_OperationService;
    public Inventory: Inventory_OperationService;
    public SalesOrders: SalesOrders_OperationService;
  public FootPrintPortalManager: FootPrintPortalManager_OperationService = this;

  public Disable_AsnOrder_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Activity');
    }
  }
  public Disable_AsnOrder_Appointments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Appointments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Appointments');
    }
  }
  public Disable_AsnOrder_Attachments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Attachments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Attachments');
    }
  }
  public Disable_AsnOrder_Cancel = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Cancel');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Cancel');
    }
  }
  public Disable_AsnOrder_Contacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Contacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Contacts');
    }
  }
  public Disable_AsnOrder_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Delete');
    }
  }
  public Disable_AsnOrder_Print = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Print');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Print');
    }
  }
  public Disable_AsnOrder_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnOrder_Update');
    }
  }
  public Disable_AsnPallets_Cancel = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Cancel');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Cancel');
    }
  }
  public Disable_AsnPallets_Creation = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Creation');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Creation');
    }
  }
  public Disable_AsnPallets_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Delete');
    }
  }
  public Disable_AsnPallets_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_AsnPallets_Update');
    }
  }
  public Disable_EmailRules_Management = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_EmailRules_Management');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_EmailRules_Management');
    }
  }
  public Disable_Inventory_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Activity');
    }
  }
  public Disable_Inventory_DateSelection = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_DateSelection');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_DateSelection');
    }
  }
  public Disable_Inventory_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Hub');
    }
  }
  public Disable_Inventory_Transactions_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Transactions_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Inventory_Transactions_Hub');
    }
  }
  public Disable_Invoice_Print = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Invoice_Print');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Invoice_Print');
    }
  }
  public Disable_Invoices_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Invoices_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Invoices_Hub');
    }
  }
  public Disable_Lot_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Activity');
    }
  }
  public Disable_Lot_Management = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Management');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Management');
    }
  }
  public Disable_Lot_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lot_Update');
    }
  }
  public Disable_Lots_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lots_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Lots_Hub');
    }
  }
  public Disable_Material_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Activity');
    }
  }
  public Disable_Material_Attachments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Attachments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Attachments');
    }
  }
  public Disable_Material_Creation = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Creation');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Creation');
    }
  }
  public Disable_Material_Management = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Management');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Management');
    }
  }
  public Disable_Material_Packagings = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Packagings');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Packagings');
    }
  }
  public Disable_Material_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Material_Update');
    }
  }
  public Disable_Materials_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Materials_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Materials_Hub');
    }
  }
  public Disable_Orders_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Orders_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Orders_Hub');
    }
  }
  public Disable_OrdersHub_CreateReceivingOrder = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_CreateReceivingOrder');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_CreateReceivingOrder');
    }
  }
  public Disable_OrdersHub_CreateShippingOrder = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_CreateShippingOrder');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_CreateShippingOrder');
    }
  }
  public Disable_OrdersHub_ImportOrders = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ImportOrders');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ImportOrders');
    }
  }
  public Disable_OrdersHub_ManageShipFromContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ManageShipFromContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ManageShipFromContacts');
    }
  }
  public Disable_OrdersHub_ManageShipToContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ManageShipToContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ManageShipToContacts');
    }
  }
  public Disable_OrdersHub_ReceivingOrders = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ReceivingOrders');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ReceivingOrders');
    }
  }
  public Disable_OrdersHub_ShippingOrders = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ShippingOrders');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_OrdersHub_ShippingOrders');
    }
  }
  public Disable_Pallet_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Activity');
    }
  }
  public Disable_Pallet_Management = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Management');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Management');
    }
  }
  public Disable_Pallet_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Pallet_Update');
    }
  }
  public Disable_Project_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_Activity');
    }
  }
  public Disable_Project_Management = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_Management');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_Management');
    }
  }
  public Disable_Project_ManageShipFromContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_ManageShipFromContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_ManageShipFromContacts');
    }
  }
  public Disable_Project_ManageShipToContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_ManageShipToContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Project_ManageShipToContacts');
    }
  }
  public Disable_Receiving_Orders_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Receiving_Orders_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Receiving_Orders_Hub');
    }
  }
  public Disable_ReceivingLines_Creation = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Creation');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Creation');
    }
  }
  public Disable_ReceivingLines_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Delete');
    }
  }
  public Disable_ReceivingLines_ImportLines = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_ImportLines');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_ImportLines');
    }
  }
  public Disable_ReceivingLines_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingLines_Update');
    }
  }
  public Disable_ReceivingOrder_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Activity');
    }
  }
  public Disable_ReceivingOrder_Appointments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Appointments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Appointments');
    }
  }
  public Disable_ReceivingOrder_Attachments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Attachments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Attachments');
    }
  }
  public Disable_ReceivingOrder_Cancel = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Cancel');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Cancel');
    }
  }
  public Disable_ReceivingOrder_Contacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Contacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Contacts');
    }
  }
  public Disable_ReceivingOrder_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Delete');
    }
  }
  public Disable_ReceivingOrder_ManageShipFromContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_ManageShipFromContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_ManageShipFromContacts');
    }
  }
  public Disable_ReceivingOrder_Print = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Print');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Print');
    }
  }
  public Disable_ReceivingOrder_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ReceivingOrder_Update');
    }
  }
  public Disable_Reports_Billing_View = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Billing_View');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Billing_View');
    }
  }
  public Disable_Reports_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Hub');
    }
  }
  public Disable_Reports_Inventory_View = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Inventory_View');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Inventory_View');
    }
  }
  public Disable_Reports_Operations_View = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Operations_View');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Operations_View');
    }
  }
  public Disable_Reports_Receiving_View = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Receiving_View');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Receiving_View');
    }
  }
  public Disable_Reports_Shipping_View = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Shipping_View');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Reports_Shipping_View');
    }
  }
  public Disable_Serial_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Serial_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Serial_Hub');
    }
  }
  public Disable_Shipping_Orders_Hub = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Shipping_Orders_Hub');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_Shipping_Orders_Hub');
    }
  }
  public Disable_ShippingLines_Cancel = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Cancel');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Cancel');
    }
  }
  public Disable_ShippingLines_Creation = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Creation');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Creation');
    }
  }
  public Disable_ShippingLines_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Delete');
    }
  }
  public Disable_ShippingLines_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingLines_Update');
    }
  }
  public Disable_ShippingOrder_Activity = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Activity');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Activity');
    }
  }
  public Disable_ShippingOrder_Appointments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Appointments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Appointments');
    }
  }
  public Disable_ShippingOrder_Attachments = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Attachments');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Attachments');
    }
  }
  public Disable_ShippingOrder_Cancel = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Cancel');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Cancel');
    }
  }
  public Disable_ShippingOrder_Contacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Contacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Contacts');
    }
  }
  public Disable_ShippingOrder_Delete = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Delete');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Delete');
    }
  }
  public Disable_ShippingOrder_Instructions = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Instructions');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Instructions');
    }
  }
  public Disable_ShippingOrder_ManageShipToContacts = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_ManageShipToContacts');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_ManageShipToContacts');
    }
  }
  public Disable_ShippingOrder_Picked = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Picked');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Picked');
    }
  }
  public Disable_ShippingOrder_Print = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Print');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Print');
    }
  }
  public Disable_ShippingOrder_Update = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Update');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_ShippingOrder_Update');
    }
  }

  private isAuthorized(operationName: string): Promise<boolean> {
    return this.utils.http.post(`${environment.backendUrl}api/FootPrintPortalManager/operations/${operationName}/isauthorized`, null);
  }
}
